/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  B2BUser,
  DefaultRoutePageMetaResolver,
  TranslationService,
} from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentUserService } from './current-user.service';

@Injectable({ providedIn: 'root' })
export class UserRoutePageMetaResolver extends DefaultRoutePageMetaResolver {
  constructor(
    translation: TranslationService,
    protected currentItemService: CurrentUserService
  ) {
    super(translation);
  }

  protected getParams(): Observable<B2BUser | undefined> {
    return this.currentItemService.item$;
  }
}
